import { ApiClient } from './client.js'
import { KEYWORD_LANDING_PAGES } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (slug) {
    return client.get(`${KEYWORD_LANDING_PAGES}${slug}/`)
  }
}
